// Vendor
import {ApolloLink} from 'apollo-link';

// Services
import {ISeeStore} from 'isee/services/redux/redux';

export const createAuthMiddleware = (store: ISeeStore) => {
  return new ApolloLink((operation, forward) => {
    const token = store.getState().session;

    operation.setContext({
      headers: {
        authorization: token ? `bearer ${token}` : ''
      }
    });

    return forward!(operation);
  });
};



// WEBPACK FOOTER //
// ./src/services/apollo/middlewares/authorization.ts